/* eslint-disable max-params */
/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, { useState, useEffect, useRef } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { useHistory } from "react-router";
import { floor } from "lodash";

import InputText from "../../shared/input-text";
import Slider from "../../shared/slider";
import ListTab from "../../shared/list-tab";
import { CAR_LIST_EVENT_NAMES, NUMBER } from "../../../constants/app-constants";
import Cars24FinanceRates from "./images/interest-label.png";
import Button from "../../shared/button";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import GreenCheck from "./images/green-check.png";
import LazyImage from "../../shared/lazy-image";
import { calculateEmiAUV2 } from "../../../utils/helpers/calculate-emi";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import debounce from "../../../utils/helpers/debounce";
import { EVENT_CONSTANTS } from "../car-details-revamp/tracking";
import { EVENT_DATA } from "./tracking";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";

const DEFAULT_TENURE_VARIANT_B = [
    {
        label: "3",
        value: 3
    },
    {
        label: "4",
        value: 4
    },
    {
        label: "5",
        value: 5
    },
    {
        label: "7",
        value: 7
    }
];

const defaultSliderProps = {
    mode: 1,
    tickCount: 10,
    railColor: "#D9E6F1",
    disabledTrackStyles: {
        backgroundColor: "#0071BC",
        backgroundImage: "linear-gradient(269deg, #0071BC, #0071BC)"
    },
    // hideTicksOnEdges: false,Car's Drive Away Price
    handleColor: "blue"
};

const FINANCE_CALCULATOR = {
    DAP: "dap",
    DEPOSIT: "deposit",
    INTEREST: "interest"
};
const onCalculatorUsed = () => {};
const calculatorUseddebounced = debounce(onCalculatorUsed, NUMBER.THOUSAND);

const LoanCalculator = ({ content, preApproved, ctaProps, setRedirectRouteConnect, minMaxInterestRateInfo, getMinMaxInterestRatesConnect, loanCalculatorInfo, stEligibleData, setPreApprovedOriginConnect }) => {
    const { estimatedPrice = 0, emiDetails, personalised } = content || {};
    const {isStEligible = false} = stEligibleData || {};
    const {
        interestRate,
        lenderFee,
        balloonPercentage,
        lenderMonthlyFee,
        tenure: defaultTenure
    } = emiDetails || {};
    const history = useHistory();
    const onBlurRef = useRef();
    // updates input value as user enters
    const { minInterestRate, maxInterestRate } = minMaxInterestRateInfo || {};
    const { interestRate: apiInterestRate } = loanCalculatorInfo || {};
    const finalInterestRate = personalised ? interestRate : apiInterestRate;
    const minRate = floor(minInterestRate, 1) || 0;
    const maxRate = floor(maxInterestRate, 1) || 1;
    const [inputParameters, setInputParameters] = useState({
        dap: +estimatedPrice <= NUMBER.FIVE_THOUSAND_FIVE_HUNDRED ? NUMBER.FIVE_THOUSAND_FIVE_HUNDRED : estimatedPrice,
        deposit: NUMBER.FIVE_HUNDRED,
        loanTenure: defaultTenure,
        interestRate: finalInterestRate
    });
    // holds final value to display on loan summary card
    const [priceState, setPriceState] = useState({
        dap: +estimatedPrice <= NUMBER.FIVE_THOUSAND_FIVE_HUNDRED ? NUMBER.FIVE_THOUSAND_FIVE_HUNDRED : estimatedPrice,
        deposit: NUMBER.FIVE_HUNDRED,
        interestRate: finalInterestRate,
        loanTenure: defaultTenure
    });
    const [simpleInterest, setSimpleInterest] = useState(0);
    const totalLoanAmount = priceState.dap - priceState.deposit;

    // eslint-disable-next-line max-params
    const handleSI = ({ dap, interestRate: rate, loanTenure, deposit }) => {
        const emiValue = calculateEmiAUV2({ loanAmount: dap - deposit, lenderFee, balloonPercentage, lenderMonthlyFee, interestRate: rate, tenure: (loanTenure) * NUMBER.FIFTY_TWO });
        setSimpleInterest(emiValue);
    };

    const interestSlider = {
        domain: [minRate, maxRate],
        defaultValues: [priceState.interestRate],
        step: 0.25,
        onUpdate: (values) => {
            calculatorUseddebounced();
            const value = values[0];
            const updatedValue = onBlurRef.current ? priceState : { ...priceState, interestRate: value };
            onBlurRef.current = false;
            setInputParameters(updatedValue);
            setPriceState(updatedValue);
            handleSI(updatedValue);
        },

        ...defaultSliderProps
    };
    const renderPersonalisedText = () => {
        if (!preApproved) {
            return (
                <p>A pre-approval will help you get personalized interest rates.</p>
            );
        } else if (isStEligible) {
            return (
                <p>
                    Get <span styleName="styles.orange">12X faster</span> loan approval
                </p>
            );
        } else {
            return (
                <p>
                    You have been <span styleName="styles.green">pre-approved</span> for finance <LazyImage src={GreenCheck} height="16.67px" width="16.67px" />
                </p>
            );
        }
    };

    useEffect(() => {
        //refect after logout resets the preapproval state
        if (!minInterestRate) {
            getMinMaxInterestRatesConnect();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [minInterestRate]);
    useEffect(() => {
        setPriceState({...inputParameters, interestRate: finalInterestRate});
        setPriceState({...priceState, interestRate: finalInterestRate});
        handleSI(inputParameters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalInterestRate]);
    const onChange = (key, e) => {
        const inputValue = e.target.value;
        switch (key) {
        case FINANCE_CALCULATOR.DAP: {
            return setInputParameters({ ...inputParameters, dap: +inputValue });
        }
        case FINANCE_CALCULATOR.DEPOSIT: {
            return setInputParameters({ ...inputParameters, deposit: +inputValue });
        }
        case FINANCE_CALCULATOR.INTEREST: {
            const sanitizedInput = inputValue.replace(/[^0-9.]+/, "");
            return setInputParameters({ ...inputParameters, interestRate: sanitizedInput });
        }
        default:
            return { ...inputParameters };
        }
    };
    const getInterestRate = (interestRateValue) => {
        if (interestRateValue < minInterestRate) {
            return minInterestRate;
        } else if (interestRateValue > maxInterestRate) {
            return maxInterestRate;
        } else {
            return interestRateValue;
        }
    };

    const onBlurInput = (value, key) => {
        const inputValue = +value;
        const minPrice = NUMBER.FIVE_THOUSAND_FIVE_HUNDRED;
        const minDeposit = NUMBER.FIVE_HUNDRED;

        switch (key) {
        case FINANCE_CALCULATOR.DAP: {
            const updatedPrice = inputValue < minPrice ? minPrice : inputValue;
            const updatedDeposit =
                    updatedPrice - inputParameters.deposit < NUMBER.FIVE_HUNDRED
                        ? NUMBER.FIVE_HUNDRED
                        : inputParameters.deposit;
            setPriceState({ ...priceState, dap: updatedPrice, deposit: updatedDeposit });
            setInputParameters({ ...inputParameters, dap: updatedPrice, deposit: updatedDeposit });
            handleSI({...inputParameters, dap: updatedPrice, deposit: updatedDeposit});
            return;
        }
        case FINANCE_CALCULATOR.DEPOSIT: {
            const updatedInputValue = inputValue < minDeposit ? minDeposit : inputValue;
            const updatedDeposit =
                    updatedInputValue > inputParameters.dap ||
                        inputParameters.dap - updatedInputValue < NUMBER.FIVE_THOUSAND
                        ? inputParameters.dap - NUMBER.FIVE_THOUSAND
                        : updatedInputValue;
            setPriceState({ ...priceState, deposit: updatedDeposit });
            setInputParameters({ ...inputParameters, deposit: updatedDeposit });
            handleSI({...inputParameters, deposit: updatedDeposit});
            return;
        }
        case FINANCE_CALCULATOR.INTEREST: {
            const updatedInterestRate = getInterestRate(inputValue);
            setPriceState({ ...priceState, interestRate: updatedInterestRate });
            setInputParameters({ ...inputParameters, interestRate: updatedInterestRate });
            handleSI({...inputParameters, interestRate: updatedInterestRate});
            onBlurRef.current = true;
            return;
        }
        default:
            return;
        }
    };
    const onChangeTenure = (id, data) => {
        onCalculatorUsed();
        setInputParameters({ ...inputParameters, loanTenure: data.value });
        setPriceState({ ...priceState, loanTenure: data.value });
        handleSI({...inputParameters, loanTenure: data.value});
    };
    const handlePreApproval = async () => {
        setRedirectRouteConnect(history.location.pathname);
        setPreApprovedOriginConnect(CAR_LIST_EVENT_NAMES.DETAILS);
        await yieldToMain();
        trackDesktopCustomEventsAU(EVENT_CONSTANTS.LOAN_CALCULATOR_CDP_ACTION, EVENT_DATA.LOAN_CALCULATOR_CDP_ACTION);
        history.push("/financing/get-pre-approval");
    };

    return (
        <div styleName={"styles.rightSectionWrap"}>
            {/* CALCULATOR */}
            <div styleName="styles.calculatorWrapper">
                <div styleName="styles.calculatorItemContainer">
                    <strong>Car’s  price</strong>
                    <div styleName={"styles.priceBox"}>
                        {<span styleName={"styles.prefixText"}>{"$"}</span>}
                        <InputText
                            id={FINANCE_CALCULATOR.DAP}
                            readOnly={false}
                            styleName="styles.price"
                            onChange={(e) => onChange(FINANCE_CALCULATOR.DAP, e)}
                            onBlurCallback={onBlurInput}
                            value={inputParameters.dap}
                            onlyNumber={true}
                            onFocusCallback={onCalculatorUsed}
                        />
                    </div>
                    <p>Final price of the car</p>
                </div>
                <div styleName="styles.calculatorItemContainer">
                    <strong>Deposit</strong>
                    <div styleName={"styles.priceBox"}>
                        {<span styleName={"styles.prefixText"}>{"$"}</span>}
                        <InputText
                            // readOnly={true}
                            id={FINANCE_CALCULATOR.DEPOSIT}
                            styleName="styles.price"
                            onChange={(e) => onChange(FINANCE_CALCULATOR.DEPOSIT, e)}
                            onBlurCallback={onBlurInput}
                            value={inputParameters.deposit}
                            onlyNumber={true}
                            onFocusCallback={onCalculatorUsed}
                        />
                    </div>
                    <p>How much money would you like to pay upfront?</p>
                </div>

                {!preApproved && <div styleName="styles.calculatorItemContainer">
                    <strong>
                        Interest rate
                        <span>
                            <LazyImage styleName="styles.interestLabel" src={Cars24FinanceRates} />
                        </span>
                    </strong>
                    <div styleName={"styles.priceBox"}>
                        {<span styleName={"styles.prefixText"}>{"%"}</span>}
                        <InputText
                            // readOnly={true}
                            type="text"
                            id={FINANCE_CALCULATOR.INTEREST}
                            styleName="styles.price"
                            onChange={(e) => onChange(FINANCE_CALCULATOR.INTEREST, e)}
                            value={inputParameters.interestRate}
                            // onlyNumber={true}
                            onBlurCallback={onBlurInput}
                            onFocusCallback={onCalculatorUsed}
                        />
                    </div>
                    <div styleName={"styles.priceSliderContainer"}>
                        <p styleName={"styles.loanMinValue"}>{minRate}%</p>
                        <Slider {...interestSlider} />
                        <p styleName={"styles.loanMaxValue"}>{maxRate}%</p>
                    </div>
                    {/* <p>Get a pre-approval to know rates personalized to your profile</p> */}
                </div>}

                <div styleName="styles.calculatorItemContainer styles.tenureSection">
                    <strong>Tenure (years)</strong>
                    <div styleName="styles.tenureWrapper">
                        {DEFAULT_TENURE_VARIANT_B.map((item) => (
                            <ListTab
                                key={item.id}
                                data={item}
                                dataKey={"value"}
                                selectedKey={inputParameters.loanTenure}
                                labelKey={"label"}
                                styleName={"styles.columns"}
                                onClick={onChangeTenure}
                                color="blue"
                            >
                                <div className="squareChip" styleName="styles.squareChip">
                                    <span>{item.label}</span>
                                </div>
                            </ListTab>
                        ))}
                    </div>
                    <p>How many years will you take to repay the loan?</p>
                </div>
            </div>

            {/* LOAN SUMMARY CARD */}
            <div>
                <div styleName="styles.summaryCardWrapper">
                    <div styleName="styles.summaryCardHeader">
                        <p styleName={`styles.summaryCardLeft ${!preApproved ? "styles.repaymentLimitSection" : ""}`}>
                            <span>${simpleInterest || 0}</span> Repayment/week
                        </p>
                        {preApproved && <p styleName="styles.summaryCardRight">
                            <span>{finalInterestRate}%</span> Interest rate
                        </p>}
                    </div>
                    <div styleName={"styles.loanAmountWrapper"}>
                        <ul>
                            <li>
                                <span>Car’s price</span>
                                <span>{makePriceLabelRound(priceState.dap)}</span>
                            </li>
                            <li>
                                <span>Deposit</span>
                                <span>-{makePriceLabelRound(priceState.deposit)}</span>
                            </li>
                            <li styleName="styles.totalLoanAmount">
                                <span>Total loan amount</span>
                                <span>{makePriceLabelRound(totalLoanAmount)}</span>
                            </li>
                        </ul>
                    </div>

                    <div styleName={"styles.buttonWrap"}>
                        <div styleName={"styles.preApprovedText"}>{renderPersonalisedText()}</div>
                        {preApproved ? <Button text={ctaProps.text} onClick={() => ctaProps.action()} /> : <Button text={"GET PRE-APPROVAL NOW"} onClick={handlePreApproval} />}
                    </div>
                </div>
                <p styleName={"styles.disclaimerText"}>
                *These estimations may vary based on other circumstances like delivery, location and additional products opted for in checkout
                </p>
            </div>

        </div>
    );
};

LoanCalculator.propTypes = {
    content: PropTypes.object,
    preApproved: PropTypes.bool,
    stEligible: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    ctaProps: PropTypes.bool,
    setRedirectRouteConnect: PropTypes.bool,
    minMaxInterestRateInfo: PropTypes.object,
    getMinMaxInterestRatesConnect: PropTypes.func,
    loanCalculatorInfo: PropTypes.object,
    stEligibleData: PropTypes.object,
    setPreApprovedOriginConnect: PropTypes.func
};

export default LoanCalculator;
